import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {SelectItem} from 'primeng/api';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-multiselect',
    template: `
        <p-tabView>
            <p-tabPanel *ngFor="let tab of field.fieldGroup; let i = index; let last = last;"
                        [header]="tab.templateOptions.label">
                <formly-field [field]="tab"></formly-field>
            </p-tabPanel>
        </p-tabView>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldTabs extends FieldType {
}
